import { jsxs as r, jsx as e } from "react/jsx-runtime";
import { Button as s } from "../Button/Button.js";
import { SimpleText as t } from "../SimpleText/SimpleText.js";
import '../../assets/Placeholder.css';function p({
  title: c,
  message: i,
  Icon: o,
  subtitle: l,
  className: d = "",
  onRetry: a
}) {
  return /* @__PURE__ */ r("div", { className: "placeholder " + d, children: [
    /* @__PURE__ */ e("div", { className: "placeholder-icon", children: o }),
    /* @__PURE__ */ e("b", { className: "placeholder-title", children: c }),
    l && /* @__PURE__ */ e("div", { className: "placeholder-subtitle", children: /* @__PURE__ */ e(t, { variant: "light", children: l }) }),
    /* @__PURE__ */ r("div", { className: "placeholder-message", children: [
      i,
      " "
    ] }),
    a && /* @__PURE__ */ e(
      s,
      {
        label: "Retry",
        onClick: a,
        className: "placeholder-button"
      }
    )
  ] });
}
export {
  p as Placeholder
};
//# sourceMappingURL=Placeholder.js.map
